import React from 'react';

export const ResizeContext = React.createContext();